export default "__VITE_ASSET__C8c5iu05__"